/*!
 * devextreme-vue
 * Version: 19.2.8
 * Build date: Fri May 15 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VueType = require("vue");
var Vue = VueType.default || VueType;
var diagram_1 = require("devextreme/ui/diagram");
var component_1 = require("./core/component");
var configuration_component_1 = require("./core/configuration-component");
var DxDiagram = Vue.extend({
    extends: component_1.DxComponent,
    props: {
        accessKey: String,
        activeStateEnabled: Boolean,
        autoZoom: String,
        contextMenu: Object,
        customShapes: Array,
        disabled: Boolean,
        edges: Object,
        elementAttr: Object,
        export: Object,
        focusStateEnabled: Boolean,
        fullScreen: Boolean,
        gridSize: [Number, Object],
        height: [Function, Number, String],
        hint: String,
        hoverStateEnabled: Boolean,
        nodes: Object,
        onContentReady: Function,
        onDataChanged: Function,
        onDisposing: Function,
        onInitialized: Function,
        onItemClick: Function,
        onItemDblClick: Function,
        onOptionChanged: Function,
        onSelectionChanged: Function,
        pageColor: String,
        pageOrientation: String,
        pageSize: Object,
        propertiesPanel: Object,
        readOnly: Boolean,
        rtlEnabled: Boolean,
        showGrid: Boolean,
        simpleView: Boolean,
        snapToGrid: Boolean,
        tabIndex: Number,
        toolbar: Object,
        toolbox: Object,
        units: String,
        viewUnits: String,
        visible: Boolean,
        width: [Function, Number, String],
        zoomLevel: [Number, Object]
    },
    computed: {
        instance: function () {
            return this.$_instance;
        }
    },
    beforeCreate: function () {
        this.$_WidgetClass = diagram_1.default;
        this.$_expectedChildren = {
            contextMenu: { isCollectionItem: false, optionName: "contextMenu" },
            customShape: { isCollectionItem: true, optionName: "customShapes" },
            edges: { isCollectionItem: false, optionName: "edges" },
            export: { isCollectionItem: false, optionName: "export" },
            gridSize: { isCollectionItem: false, optionName: "gridSize" },
            nodes: { isCollectionItem: false, optionName: "nodes" },
            pageSize: { isCollectionItem: false, optionName: "pageSize" },
            propertiesPanel: { isCollectionItem: false, optionName: "propertiesPanel" },
            toolbar: { isCollectionItem: false, optionName: "toolbar" },
            toolbox: { isCollectionItem: false, optionName: "toolbox" },
            zoomLevel: { isCollectionItem: false, optionName: "zoomLevel" }
        };
    }
});
exports.DxDiagram = DxDiagram;
var DxAutoLayout = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        orientation: String,
        type: String
    }
});
exports.DxAutoLayout = DxAutoLayout;
DxAutoLayout.$_optionName = "autoLayout";
var DxConnectionPoint = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        x: Number,
        y: Number
    }
});
exports.DxConnectionPoint = DxConnectionPoint;
DxConnectionPoint.$_optionName = "connectionPoints";
DxConnectionPoint.$_isCollectionItem = true;
var DxContextMenu = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        commands: Array,
        enabled: Boolean
    }
});
exports.DxContextMenu = DxContextMenu;
DxContextMenu.$_optionName = "contextMenu";
var DxCustomShape = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        allowEditImage: Boolean,
        allowEditText: Boolean,
        backgroundImageHeight: Number,
        backgroundImageLeft: Number,
        backgroundImageTop: Number,
        backgroundImageUrl: String,
        backgroundImageWidth: Number,
        baseType: String,
        category: String,
        connectionPoints: Array,
        defaultHeight: Number,
        defaultImageUrl: String,
        defaultText: String,
        defaultWidth: Number,
        imageHeight: Number,
        imageLeft: Number,
        imageTop: Number,
        imageWidth: Number,
        textHeight: Number,
        textLeft: Number,
        textTop: Number,
        textWidth: Number,
        title: String,
        type: String
    }
});
exports.DxCustomShape = DxCustomShape;
DxCustomShape.$_optionName = "customShapes";
DxCustomShape.$_isCollectionItem = true;
DxCustomShape.$_expectedChildren = {
    connectionPoint: { isCollectionItem: true, optionName: "connectionPoints" }
};
var DxEdges = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        dataSource: [Array, Object],
        fromExpr: [Function, String],
        fromLineEndExpr: [Function, String],
        fromPointIndexExpr: [Function, String],
        keyExpr: [Function, String],
        lineTypeExpr: [Function, String],
        lockedExpr: [Function, String],
        pointsExpr: [Function, String],
        styleExpr: [Function, String],
        textExpr: [Function, String],
        textStyleExpr: [Function, String],
        toExpr: [Function, String],
        toLineEndExpr: [Function, String],
        toPointIndexExpr: [Function, String],
        zIndexExpr: [Function, String]
    }
});
exports.DxEdges = DxEdges;
DxEdges.$_optionName = "edges";
var DxExport = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        fileName: String,
        proxyUrl: String
    }
});
exports.DxExport = DxExport;
DxExport.$_optionName = "export";
var DxGridSize = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        items: Array,
        value: Number
    }
});
exports.DxGridSize = DxGridSize;
DxGridSize.$_optionName = "gridSize";
var DxGroup = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        category: String,
        commands: Array,
        displayMode: String,
        expanded: Boolean,
        shapes: Array,
        title: String
    }
});
exports.DxGroup = DxGroup;
DxGroup.$_optionName = "groups";
DxGroup.$_isCollectionItem = true;
var DxItem = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        height: Number,
        text: String,
        width: Number
    }
});
exports.DxItem = DxItem;
DxItem.$_optionName = "items";
DxItem.$_isCollectionItem = true;
var DxNodes = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        autoLayout: [Object, String],
        childrenExpr: [Function, String],
        containerKeyExpr: [Function, String],
        dataSource: [Array, Object],
        heightExpr: [Function, String],
        imageUrlExpr: [Function, String],
        itemsExpr: [Function, String],
        keyExpr: [Function, String],
        leftExpr: [Function, String],
        lockedExpr: [Function, String],
        parentKeyExpr: [Function, String],
        styleExpr: [Function, String],
        textExpr: [Function, String],
        textStyleExpr: [Function, String],
        topExpr: [Function, String],
        typeExpr: [Function, String],
        widthExpr: [Function, String],
        zIndexExpr: [Function, String]
    }
});
exports.DxNodes = DxNodes;
DxNodes.$_optionName = "nodes";
DxNodes.$_expectedChildren = {
    autoLayout: { isCollectionItem: false, optionName: "autoLayout" }
};
var DxPageSize = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        height: Number,
        items: Array,
        width: Number
    }
});
exports.DxPageSize = DxPageSize;
DxPageSize.$_optionName = "pageSize";
DxPageSize.$_expectedChildren = {
    item: { isCollectionItem: true, optionName: "items" }
};
var DxPropertiesPanel = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        collapsible: Boolean,
        enabled: Boolean,
        groups: Array
    }
});
exports.DxPropertiesPanel = DxPropertiesPanel;
DxPropertiesPanel.$_optionName = "propertiesPanel";
DxPropertiesPanel.$_expectedChildren = {
    group: { isCollectionItem: true, optionName: "groups" },
    propertiesPanelGroup: { isCollectionItem: true, optionName: "groups" }
};
var DxPropertiesPanelGroup = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        commands: Array
    }
});
exports.DxPropertiesPanelGroup = DxPropertiesPanelGroup;
DxPropertiesPanelGroup.$_optionName = "groups";
DxPropertiesPanelGroup.$_isCollectionItem = true;
var DxToolbar = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        commands: Array,
        visible: Boolean
    }
});
exports.DxToolbar = DxToolbar;
DxToolbar.$_optionName = "toolbar";
var DxToolbox = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        groups: Array,
        visible: Boolean
    }
});
exports.DxToolbox = DxToolbox;
DxToolbox.$_optionName = "toolbox";
DxToolbox.$_expectedChildren = {
    group: { isCollectionItem: true, optionName: "groups" },
    toolboxGroup: { isCollectionItem: true, optionName: "groups" }
};
var DxToolboxGroup = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        category: String,
        displayMode: String,
        expanded: Boolean,
        shapes: Array,
        title: String
    }
});
exports.DxToolboxGroup = DxToolboxGroup;
DxToolboxGroup.$_optionName = "groups";
DxToolboxGroup.$_isCollectionItem = true;
var DxZoomLevel = Vue.extend({
    extends: configuration_component_1.DxConfiguration,
    props: {
        items: Array,
        value: Number
    }
});
exports.DxZoomLevel = DxZoomLevel;
DxZoomLevel.$_optionName = "zoomLevel";
exports.default = DxDiagram;
